import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const SubNav = styled(Box)(({ theme }) => ({
  width: 232,
  flex: "0 0 232px",
  borderRight: `1px solid ${theme.palette.divider}`,
  overflow: "auto",
  padding: "12px 8px",
  background: theme.palette.background.paper,
}));

export const GroupHead = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: 0.5,
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
  padding: "10px 12px 6px",
}));

export const NavItem = styled(Box, {
  shouldForwardProp: prop => prop !== "active",
})<{ active?: boolean }>(({ theme, active }) => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  padding: "9px 12px",
  marginLeft: 8,
  borderRadius: 8,
  fontSize: 14,
  cursor: "pointer",
  color: active ? theme.palette.primary.dark : theme.palette.text.secondary,
  fontWeight: active ? 600 : 400,
  background: active ? `${theme.palette.primary.main}1f` : "transparent",
  "&:hover": {
    background: active ? `${theme.palette.primary.main}1f` : "rgba(0,0,0,0.04)",
  },
}));
